<template>
  <div class="message_template" :style="screenHeight">
    <div class="fixed_search" style="height: 100px">
      <div class="fixed_search_input">
        <Input v-model="caller" placeholder="请输入主叫号码" title="主叫号码"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="callee" placeholder="请输入被叫号码" title="被叫号码"/>
      </div>
      <div class="date_selected fixed_search_input">
        <el-date-picker v-model="callerStartTime" unlink-panels type="datetimerange" start-placeholder="主叫开始时间" end-placeholder="主叫结束时间" align="left" :default-time="['00:00:00', '23:59:59']" :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div class="fixed_search_input">
        <Select v-model="type" placeholder="请选择呼叫类型" clearable title="呼叫类型">
          <Option v-for="(option, index) in callTypeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select v-model="callerStatus" placeholder="请选择主叫通话状态" clearable title="主叫通话状态">
          <Option v-for="(option, index) in hangUpTypeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select v-model="calleeStatus" placeholder="请选择被叫通话状态" clearable title="被叫通话状态">
          <Option v-for="(option, index) in hangUpTypeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Input v-model="queueName" placeholder="请输入技能组名称" title="技能组名称"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="pstnNumber" placeholder="请输入热线号码" title="热线号码"/>
      </div>
      <div class="fixed_search_input">
        <Select v-model="countdown" placeholder="刷新时间选择" @on-change="handleCountdown">
          <Option v-for="(item,index) in countdownList" :value="item.value" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="fixed_operation_btn">
        <span title="刷新倒计时" style="color: red;margin-right: 5px">{{countdownTime}}</span>
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
      </div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" stripe ref="selection" @selection-change="getSelectedId">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
      </el-table>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "MessageRecord",
    mixins:[publicFunClass],
    props:{
      pageCode:String
    },
    data(){
      return {
        countdown:'0',
        countdownTime:0,
        historyRefreshTime:0,
        countdownList:[{'value':'0','name':'停止刷新'},{'value':'5','name':'每隔5秒刷新'},{'value':'10','name':'每隔10秒刷新'},{'value':'15','name':'每隔15秒刷新'},{'value':'20','name':'每隔20秒刷新'},{'value':'25','name':'每隔25秒刷新'},{'value':'30','name':'每隔30秒刷新'}],
        showPageCount:0,
        total:0,
        currentPage:1,
        speedChangePage: 1,
        pageSize:20,
        editable:false,
        pageSizeList:[10,20,30,40,50,100,200],
        roleList:JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        tableHeight:600,
        screenHeight:{height:''},
        callTypeList:[{'id':'0','name':'呼入'},{'id':'1','name':'手动呼出'},{'id':'2','name':'自动呼出'},{'id':'3','name':'座席互打'}],
        hangUpTypeList:[{'id':'0','name':'未接通'},{'id':'1','name':'已接通'}],
        spinShow: true,
        checkIds:[],
        fieldList: [
          {key:'caller','title':'主叫号码'},{key:'callee','title':'被叫号码'},{key:'callerStartTime',width: 200,'title':'主叫开始时间'},
          {key:'type','title':'呼叫类型'},{key:'callerStatus',width: 150,'title':'主叫通话状态'},{key:'calleeStatus',width: 150,'title':'被叫通话状态'},
          {key:'queueName',width: 100,'title':'技能组名称'},{key:'pstnNumber','title':'热线号码'}
        ],
        contentList: [],
        calleeStartTime: [],
        callerStartTime: [],
        queueName:'',
        pstnNumber:'',
        type:'',
        callerStatus:'',
        calleeStatus:'',
        callee:'',
        caller:'',
        Interval:''
      }
    },
    methods:{
      //切换刷新时间
      handleCountdown:function(val){
        if(val){
           this.countdownTime= parseInt(val);
        }else{
          if(this.countdownTime <= 0)
          return;
        }
        if(val=='0'){
          clearInterval(this.Interval);
          return false;
        }
        clearInterval(this.Interval);
        let that=this;
        this.Interval= setInterval(() =>{
          that.initCountdown();
        },1000);
      },
      initCountdown:function () {
        this.countdownTime=this.countdownTime-1;
        if(this.countdownTime==0){
          this.countdownTime=parseInt(this.countdown);
          this.initSearch();
          return false;
        }
      },
      reset:function(){
        this.calleeStartTime='';
        this.callerStartTime=[];
        this.queueName='';
        this.pstnNumber='';
        this.type='';
        this.callerStatus='';
        this.calleeStatus='';
        this.callee='';
        this.caller='';
      },
      initSearch:function () {
        let that=this;
        this.spinShow=true;
        let param={
          pstnNumber:this.pstnNumber,
          calleeStartTime:this.calleeStartTime.length==0?"":this.calleeStartTime.toString(),
          callerStartTime:this.callerStartTime.length==0?"":this.callerStartTime.toString(),
          queueName:this.queueName,
          type:this.type,
          callerStatus:this.callerStatus,
          calleeStatus:this.calleeStatus,
          callee:this.callee,
          caller:this.caller,
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          journalType:"null",
          menuId:"null"
        };
        this.$http.post("monitor/selectCurrCall.json",param) .then(function (res) {
          that.spinShow=false;
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          let obj=res.data.obj;
          that.contentList=obj.content;
          that.total=res.data.obj.totalSize;
        });
      }
    },
    created(){
      this.screenHeight.height=this.mountHeight(91);
      let clientHeight=document.documentElement.clientHeight;
      this.tableHeight=clientHeight-230;
    },
    destroyed(){
      clearInterval(this.Interval);
    },
    watch:{
      calleeStartTime:function () {
        if(!this.calleeStartTime){
          this.calleeStartTime=[];
        }
      },
      callerStartTime:function () {
        if(!this.callerStartTime){
          this.callerStartTime=[];
        }
      },
      pageCode:function () {
        if(this.pageCode=='7_2-1' && this.showPageCount==0){
          this.showPageCount++;
          this.initSearch();
        }
        if(this.pageCode=='7_2-1'){
          this.handleCountdown();
        }
        if(this.pageCode!='7_2-1'){
          clearInterval(this.Interval);
          clearInterval(this.Interval);
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MonitorManage/CurrentCall.vue